var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col order-1 order-lg-2" }, [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "col-md-6 offset-md-3 bg-light p-5" }, [
        _c("h1", { staticClass: "h4 text-center" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("translate")("Create an account")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", { attrs: { for: "inputName" } }, [
              _c("small", [_vm._v(_vm._s(_vm._f("translate")("Name")))]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "inputName",
                required: "",
                autofocus: "",
              },
              domProps: { value: _vm.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.name = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("InputErrors", { attrs: { name: "name", errors: _vm.errors } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", { attrs: { for: "inputLastName" } }, [
              _c("small", [_vm._v(_vm._s(_vm._f("translate")("Last name")))]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.lastName,
                  expression: "lastName",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "inputLastName",
                required: "",
                autofocus: "",
              },
              domProps: { value: _vm.lastName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.lastName = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("InputErrors", { attrs: { name: "name", errors: _vm.errors } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", { attrs: { for: "inputEmail" } }, [
              _c("small", [_vm._v(_vm._s(_vm._f("translate")("Email")))]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "email",
                id: "inputEmail",
                required: "",
                autofocus: "",
              },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("InputErrors", { attrs: { name: "email", errors: _vm.errors } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", { attrs: { for: "inputPassword" } }, [
              _c("small", [_vm._v(_vm._s(_vm._f("translate")("Password")))]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "password", id: "inputPassword", required: "" },
              domProps: { value: _vm.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.password = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("InputErrors", {
              attrs: { name: "password", errors: _vm.errors },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3 text-center my-4" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.register.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Create an account")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted text-center" }, [
          _c("div", { staticClass: "mt-3" }, [
            _c("small", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm._f("translate")("By signing up, you agree to our")
                  ) +
                  "\n          "
              ),
              _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
                _vm._v(_vm._s(_vm._f("translate")("Terms"))),
              ]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("translate")("and")) +
                  "\n          "
              ),
              _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("translate")("Privacy Policy")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }